import React, { useState, Fragment } from 'react';
import * as ApiModels from '@typings/api-models';
import BackButton from '@components/BackButton';
import SingleSubscription from '@lib/SingleSubscription';
import SubscriptionListItem from '@components/SubscriptionListItem';
import * as graphQLModels from '@typings/graphql-models';

import s from './UserSubscriptions.module.scss';

type Subscription = Parameters<typeof SubscriptionListItem>[0]['item'] &
  Parameters<typeof SingleSubscription>[0]['subscription'] & {
    createdAt: ApiModels.Scalars['DateTime'];
    subscriptionModel?: {
      product?: {
        image?: { url: string } | null;
      } | null;
    } | null;
  };

type Props = {
  creatorSlug: string;
  subscriptions: Array<Subscription>;
  creatorId: string;
  stripeAccountId: string | null;
  activeType: string | null;
  setActiveType: (activityType: string | null) => void;
  retryPayment: (id: string) => Promise<void>;
};

const UserSubscriptions: React.FC<Props> = ({ retryPayment, creatorSlug, subscriptions, creatorId, stripeAccountId, activeType, setActiveType }) => {
  const [activeSubscription, setActiveSubscription] = useState<Subscription | null>(null);

  const handleSelectSection = (): void => {
    setActiveType('subscriptions');
  };

  if (activeType && activeType === 'subscriptions') {
    return (
      <Fragment>
        {activeSubscription && stripeAccountId && (
          <>
            {subscriptions.map(item => (
              <SubscriptionListItem
                key={item.id}
                item={item}
                setActiveSubscription={() => {
                  setActiveType(null);
                }}
                isOpen={activeType && activeType === 'subscriptions'}
              />
            ))}
            <SingleSubscription
              creatorId={creatorId}
              creatorSlug={creatorSlug}
              subscription={activeSubscription}
              stripeAccountId={stripeAccountId}
              setActiveSubscription={setActiveSubscription}
              retryPayment={retryPayment}
            />
          </>
        )}
        {!activeSubscription && subscriptions && !!subscriptions.length && (
          <Fragment>
            <BackButton className={s['back-button']} backLink={'#'} backAction={() => setActiveType(null)} />
            {subscriptions.map(item => (
              <SubscriptionListItem key={item.id} item={item} setActiveSubscription={setActiveSubscription} />
            ))}
          </Fragment>
        )}
      </Fragment>
    );
  }

  return (
    <Fragment>
      {subscriptions
        .filter(
          item =>
            item.subscriptionStatus !== graphQLModels.SubscriptionStatus.Incomplete
            && item.subscriptionStatus !== graphQLModels.SubscriptionStatus.IncompleteExpired,
        )
        .map(item => (
          <SubscriptionListItem
            key={item.id}
            item={item}
            setActiveSubscription={subscription => {
              handleSelectSection();
              setActiveSubscription(subscription);
            }}
          />
        ))}
    </Fragment>
  );
};

export default UserSubscriptions;
